import { atom, swr } from '@exodus/headless-ui';
import toAssetsAtom from './to-assets.js';
import prefillIdAtom from './prefill-id.js';
import prefillsAtom from './prefills.js';
import fromAssetsAtom from './from-assets.js';
const isLoadingAtom = atom((get, { selectors }) => {
    const prefills = get(swr(prefillsAtom));
    const fiatRatesLoading = get(selectors.rates.loading);
    const availableFromAssets = get(swr(fromAssetsAtom));
    const availableToAssets = get(swr(toAssetsAtom));
    const prefillId = get(prefillIdAtom);
    const isLoadingPrefills = Boolean(prefillId && prefills.loading);
    const isLoadingData = Boolean(fiatRatesLoading || availableFromAssets.loading || availableToAssets.loading);
    return isLoadingData || isLoadingPrefills;
});
export default isLoadingAtom;
